import { Pagination } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";

const TablePagination = ({onChange=()=>{}, ...props}) => {
    const maxViewPage = 5;
    const [currentPage, setCurrentPage] = useState(props.currentPage);
    const [perPage, setPerPage] = useState(props.perPage);
    const totalPage = Math.ceil(props.total / perPage);
    const pageGroup = Math.ceil(currentPage / maxViewPage);
    const startPage = (pageGroup - 1) * maxViewPage + 1;
    const endPage = Math.min(pageGroup * maxViewPage, totalPage);
    const viewPage = endPage - startPage + 1;
    const lastPage = pageGroup * maxViewPage - (maxViewPage - viewPage);
    const firstPage = lastPage - (viewPage - 1);

    const firstUpdate = useRef(true);

    
    useEffect(() => {
        setPerPage(perPage);
    },[perPage]);
    
    useEffect(() => {
        if(firstUpdate.current) {
            firstUpdate.current = false;
        } else {
            onChange(currentPage);
        }
    },[currentPage]);

    useEffect(() => {
        setCurrentPage(props.currentPage);
    },[props.currentPage]);
    useEffect(() => {
        setPerPage(props.perPage);
    },[props.perPage]);

    return (
        <Pagination>
            {
            totalPage > 1 &&
            <>
                <Pagination.First
                onClick={() => {
                    const resultPage = firstPage - 1;
                    if (resultPage >= 1) {
                        setCurrentPage(resultPage);
                    }else {
                        setCurrentPage(1);
                    }
                }} />
                <Pagination.Prev onClick={() => {
                    const resultPage = currentPage-1;
                    if (resultPage >= 1) {
                        setCurrentPage(resultPage);
                    }
                }} />
            </>
            }
            {
            Array(viewPage > 0 ? viewPage : 1).fill(0).map((v, i) => {
                const value = firstPage + i;
                return (
                    <Pagination.Item key={i} 
                        active={value == currentPage || viewPage == 1} 
                        data-page={value} onClick={(e) => {
                        setCurrentPage(e.target.getAttribute("data-page"));
                    }}>
                        {value}
                    </Pagination.Item>
                );
            })
            }
            {
            totalPage > 1 &&
            <>
                <Pagination.Next onClick={() => {
                    const resultPage = currentPage + 1;
                    if (resultPage <= totalPage) {
                        setCurrentPage(resultPage);
                    }
                }} />
                <Pagination.Last onClick={() => {
                    const resultPage = lastPage + 1;
                    if (resultPage <= totalPage) {
                        setCurrentPage(resultPage);
                    } else {
                        setCurrentPage(totalPage);
                    }
                }} />
            </>
            }
        </Pagination>
    )
}

export default TablePagination